import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { styled } from "@mui/system";
import NotFoundImage from "../assets/images/bg/notfound.svg";

const NotFoundIllustration = styled("img")({
  width: "100%",
  maxWidth: "700px",
  height: "auto",
  display: "block",
  marginLeft: "auto",
  marginRight: "auto",
});

const NotFoundContainer = styled(Container)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  minHeight: "100vh",
  textAlign: "center",
  padding: theme.spacing(4),
  [theme.breakpoints.up("md")]: {
    flexDirection: "row",
    textAlign: "left",
    justifyContent: "space-around",
  },
}));

const TextContent = styled(Box)(({ theme }) => ({
  marginBottom: theme.spacing(4),
  [theme.breakpoints.up("md")]: {
    maxWidth: "400px",
    marginBottom: 0,
    marginRight: theme.spacing(8),
  },
}));

function NotFound() {
  return (
    <NotFoundContainer>
      <TextContent>
        <Typography
          variant="h2"
          component="h1"
          sx={{ fontWeight: 700, color: "#333", mb: 2 }}
        >
          Page{" "}
          <Box
            component="span"
            sx={{
              background: "linear-gradient(#0ab9cc, #069dae)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
              display: "inline-block",
              fontWeight: 700,
            }}
          >
            404
          </Box>{" "}
          <br /> Not Found
        </Typography>
        <Typography variant="body1" sx={{ color: "#666", mb: 4 }}>
          Sorry, the page you’re looking for doesn’t exist or has been moved.
          Please check the URL, or click the button below to return to your
          dashboard.
        </Typography>

        <Button
          sx={{
            backgroundImage: "linear-gradient(#0ab9cc, #069dae)",
            border: "1px solid hsl(186, 89.90%, 27.30%)",
            borderRadius: "4px",
            color: "#fff",
            fontSize: { xs: "14px", sm: "16px" },
            padding: "4px 10px",
            textTransform: "none",
            "&:hover": {
              backgroundImage: "linear-gradient(#0991a2, #057d8c)",
            },
          }}
          onClick={() => window.location.replace("/dashboard")}
        >
          Go To Dashboard
        </Button>
      </TextContent>
      <Box sx={{ flexShrink: 0 }}>
        <NotFoundIllustration
          src={NotFoundImage}
          alt="Page Not Found Illustration"
        />
      </Box>
    </NotFoundContainer>
  );
}

export default NotFound;
